import React from 'react';
import styled from 'styled-components';
import { Box } from '../Box/Box';
const StyledOverlay = /*#__PURE__*/styled(Box).withConfig({
  displayName: "Overlay__StyledOverlay",
  componentId: "sc-1sjn08-0"
})(["position:fixed;top:0;bottom:0;left:0;right:0;opacity:", ";cursor:pointer;display:", ";"], ({
  overlayOpacity
}) => overlayOpacity, ({
  popoverOpen
}) => popoverOpen ? 'block' : 'none');
const Overlay = ({
  overlayOpacity,
  isOpen
}) => {
  return React.createElement(StyledOverlay, {
    "aria-hidden": 'true',
    tabIndex: '-1',
    popoverOpen: isOpen,
    overlayOpacity: overlayOpacity,
    color: 'background.darkest'
  });
};
export default Overlay;